// Domini consentiti anche quando i cookie di tracciamento sono bloccati
const ALLOWED_DOMAINS = [
  'pienissimo.pro',
  'forms.pienissimo.pro',
  window.location.hostname, // Dominio del sito stesso
];

// Nomi di cookie comuni di tracciamento da bloccare
const TRACKING_COOKIE_PATTERNS = [
  /^_ga/,           // Google Analytics
  /^_gid/,          // Google Analytics
  /^_gat/,          // Google Analytics
  /^_fbp/,          // Facebook Pixel
  /^_fbc/,          // Facebook Pixel
  /^_pin/,          // Pinterest
  /^_pinterest/,    // Pinterest
  /^_li/,           // LinkedIn
  /^_linkedin/,     // LinkedIn
  /^_tt/,           // TikTok
  /^_tiktok/,       // TikTok
  /^_snap/,         // Snapchat
  /^_scid/,         // Snapchat
  /^_twid/,         // Twitter
  /^_twitter/,      // Twitter
  /^utm_/,          // UTM tracking
  /^__utm/,         // Google Analytics UTM
  /^hubspot/,       // HubSpot
  /^_hs/,           // HubSpot
  /^intercom/,      // Intercom
  /^_intercom/,     // Intercom
  /^amplitude/,     // Amplitude
  /^mixpanel/,      // Mixpanel
  /^segment/,       // Segment
];

/**
 * Verifica se un cookie è di tracciamento
 */
function isTrackingCookie(name: string, domain?: string): boolean {
  // Se non c'è dominio specificato, è un cookie di prima parte (sempre permesso)
  if (!domain) {
    return false;
  }

  // Permetti sempre cookie di domini consentiti
  const isAllowedDomain = ALLOWED_DOMAINS.some(allowed => {
    // Rimuovi il punto iniziale se presente (es. .pienissimo.pro -> pienissimo.pro)
    const cleanDomain = domain.replace(/^\./, '');
    const cleanAllowed = allowed.replace(/^\./, '');
    return cleanDomain.includes(cleanAllowed) || cleanAllowed.includes(cleanDomain);
  });

  if (isAllowedDomain) {
    return false; // Non è un cookie di tracciamento se è di un dominio consentito
  }

  // Controlla se il nome del cookie corrisponde a pattern di tracciamento
  return TRACKING_COOKIE_PATTERNS.some(pattern => pattern.test(name));
}

/**
 * Verifica se i cookie di tracciamento sono bloccati
 */
export function areTrackingCookiesBlocked(): boolean {
  const consent = sessionStorage.getItem('cookieConsent');
  return consent === 'rejected';
}

/**
 * Intercetta e blocca i cookie di tracciamento
 */
export function setupCookieBlocking() {
  if (!areTrackingCookiesBlocked()) {
    return; // Non bloccare se l'utente ha accettato
  }

  // Salva il setter originale di document.cookie
  const originalCookieDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') ||
    Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');

  if (!originalCookieDescriptor) {
    return;
  }

  const originalGetter = originalCookieDescriptor.get;
  const originalSetter = originalCookieDescriptor.set;

  // Override del setter di document.cookie
  Object.defineProperty(document, 'cookie', {
    get: originalGetter,
    set: function(value: string) {
      if (!value) {
        return;
      }

      // Estrai nome e dominio dal cookie
      const parts = value.split(';');
      const nameValue = parts[0].split('=')[0].trim();
      const domainMatch = value.match(/domain=([^;]+)/i);
      const domain = domainMatch ? domainMatch[1].trim() : undefined;

      // Blocca solo cookie di tracciamento
      if (isTrackingCookie(nameValue, domain)) {
        console.log(`[Cookie Blocker] Bloccato cookie di tracciamento: ${nameValue}`);
        return; // Non impostare il cookie
      }

      // Permetti cookie non di tracciamento
      if (originalSetter) {
        originalSetter.call(this, value);
      }
    },
    configurable: true,
  });
}

/**
 * Rimuove il blocco dei cookie
 */
function removeCookieBlocking() {
  // Ripristina il comportamento originale di document.cookie
  try {
    delete (document as any).cookie;
  } catch (e) {
    // Ignora errori se non è possibile rimuovere
  }
}

/**
 * Inizializza il sistema di blocco cookie
 */
export function initCookieManager() {
  // Setup del blocco cookie se necessario
  if (areTrackingCookiesBlocked()) {
    setupCookieBlocking();
  }

  // Ascolta i cambiamenti nel sessionStorage per aggiornare il blocco
  // Nota: questo evento funziona solo tra tab diverse, non nella stessa tab
  window.addEventListener('storage', (e) => {
    if (e.key === 'cookieConsent') {
      if (e.newValue === 'rejected') {
        setupCookieBlocking();
      } else if (e.newValue === 'accepted') {
        removeCookieBlocking();
      }
    }
  });
}

